import { useEffect, useState } from 'react';
import systematic from '../../../config/systematic';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utilsTsx/universal/AntDraggableModal';
import RoleSelect from './customize/RoleSelect';

/** 当新增会员时配置默认角色 */
const NewUserRoleConfig = (props: any) => {
    const { closeModal } = props;
    const [userTypeData, setUserTypeData] = useState<any>();
    const [roleData, setRoleData] = useState<any>();
    const [vlue, setValue] = useState<any>();
    /** 后端数据bmService */
    const bmService = systematic.bmService;

    useEffect(() => {
        fetchApi.GET(bmService, {
            apiId: 'role',
            apiExtend: 'showList',
        }).then((res) => {
            if (res.success) {
                setRoleData(res.data);
            }
        });
        fetchApi.GET(bmService, {
            apiId: 'configNodes',
            apiExtend: 'getConfig',
            apiData: { id: 'newUserRoleConfig' }
        }).then((res) => {
            if (res.success) {
                setValue(JSON.stringify(res.data));
            }
        });
        fetchApi.GET(bmService, {
            apiId: 'generalData',
            apiVariable: 'userType',
            apiExtend: 'showLists',
        }).then((res) => {
            if (res.success) {
                const { userType } = res.data;
                setUserTypeData(userType);
            }
        });
    }, []);

    const handleOk = () => {
        closeModal();
    };

    return (
        <>
            <AntDraggableModal
                title='会员角色配置'
                open={true}
                okText='关闭'
                onOk={handleOk}
                cancelButtonProps={{ style: { display: "none" } }}
                closable={false}
                maskClosable={false}
                width={800}>
                <RoleSelect
                    userTypes={userTypeData}
                    roles={roleData}
                    value={vlue}
                    onChange={(str) => {
                        setValue(str);
                        fetchApi.PUT(bmService, {
                            apiId: 'configNodes',
                            apiExtend: 'setConfig',
                            apiData: {
                                id: 'newUserRoleConfig',
                                content: JSON.parse(str)
                            }
                        });
                    }}
                />
            </AntDraggableModal>
        </>
    )
}

export default NewUserRoleConfig;